import {useState, useRef} from "react";
import TableMap from "./TableMap.js";
import FormTable from "./FormTable.js";
import InfoDisplayer from "./InfoDisplayer";
import PaymentMessage from "./PaymentMessage.js";

// reactstrap components
import {
  Button,
  Container,
  Card,
  CardHeader,
  CardBody,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Row,
  Col,
  CardFooter,
  Input,
  FormGroup
} from "reactstrap";
import { isCallOrNewExpression } from "typescript";

// core components

function TableChoice({toSheet, formReceived, isFree, updateTable, displayTable, setDisplayTable, setLoading}) {

  const [nbPers, setNbPers] = useState(1)
  const [year, setYear] = useState(1)
  const [isUPHF, setIsUPFH] = useState(false)
  const [payment, setPayment] = useState('')
  const [formSent, setFormSent] = useState(false)

  const [iconPills, setIconPills] = useState("0");

  const [tableChoice, setTableChoice] = useState('')

  const [displayForm, setDisplayForm] = useState(false)

  const searchTable = (e) => {
    e.preventDefault()
    setLoading(true)
    updateTable(e)
    console.log("is it2? ", isUPHF)
  }

  const validTable = (e, id) => {
    setDisplayForm(true)
    setDisplayTable(false)
    setTableChoice(id)

    setAllInfo(Array(parseInt(nbPers)))
    setTimeout(function(){    window.scrollTo({
        left: 0,
        top: document.getElementById("table-scroll").getBoundingClientRect().y,
      })}, 500);
  }

  const tableFormat = (tableName) => {
    return (parseInt(tableName[0], 36) - 10) * 11 + parseInt(tableName.slice(1))
  }

  const [allInfo, setAllInfo] = useState([]);

  const addInfo = (info) => {

    if (!info.firstName || !info.lastName || !info.email || ((info.category.includes("INSA") || info.category.includes("Diplômé")) && (info.year < 1)) || !info.category) {
        alert('Il manque un élément de réponse au formulaire')
        return
    }

    setAllInfo([...allInfo].map((inf, index) => index == iconPills ? {...inf, firstName: info.firstName, 
        lastName: info.lastName,
        email: info.email,
        table: tableChoice, 
        year: info.year, 
        payment: 'invité',
        category: info.category,
        price: info.price,
        age: info.age, 
        vegetarian: info.isVege,
        allergies: info.allergies,
        complete: true,
        id: iconPills
    } : {...inf})) 
  }

  const registerInfo = (e) => {
        if (!payment) {
            alert('Veuillez choisir un moyen de paiement.')
            return
        }

        if (allInfo < 1) {
            alert('Veuilez enregistrer au moins une personne.')
            return
        }

        for (let i = 0; i < allInfo.length; i++) {
            if (!allInfo[i].hasOwnProperty('complete')) {
                alert(`Le formulaire n°${i + 1} n'est pas complet.`)
                return
            }
        }
        
        allInfo.map(function(info) {
            if (info.id == 0) {info.payment = payment}
            return info
        })

        setFormSent(true)

        toSheet(allInfo)
  }

  const calcTotalPrice = () => {
    if (allInfo[0]) {
        let tot = 0
        for (let i = 0; i < allInfo.length; i++) {
            if (allInfo[i].price > 0) tot += allInfo[i].price
        }
        return tot
    }
    return 0
  }

  let navForm = [
    ...Array(parseInt(nbPers - 1)),
  ].map((_, index) => {
    return <NavItem key={index}>
                <NavLink
                className={iconPills === index + 1 ? "active" : ""}
                href=""
                onClick={(e) => {
                    e.preventDefault();
                    setIconPills(index + 1);
                }}
                >
                Invité {index + 1}
                </NavLink>
            </NavItem>
  })

  let tabForm = [
    ...Array(parseInt(nbPers - 1)),
  ].map((_, index) => {
    return  <TabPane tabId={`iconPills${index + 1}`} key={index}>
                <FormTable addInfo={addInfo}/>
            </TabPane>
  })


  return (
    <>
      <div className="section section-basic" id="table-choice-section" style={{backgroundColor:/*  "#0560B8" */"#2c2c2c", color: "white"}} >
        <Container>
        <div className="title">
            <h2>Tarifs &amp; Réservations</h2>
        </div>
          <h5><strong>Tarifs :</strong></h5>
          <div className="text-justify">
          Le prix des places est de :
            <ul>
              <li>42€ pour les étudiants de l’INSA (1A, 2A, 3A, 4A et 5A) et les nouveaux diplômés (DRT inclus)</li>
              <li>45€ pour les internes à l'UPHF</li>
              <li>50€ pour les personnes extérieures</li>
            </ul>
            <br></br>
            <br></br>
            De nombreux moyens de paiements vous sont proposés afin de vous faciliter la tâche.
            Nouveauté cette année :
            <ul>
                <li><a href="https://collecte.io/gala-la-tete-dans-les-etoiles-05-03-2022-1009556/fr" target="_blank">Notre billetterie en ligne Lydia</a>, dans laquelle vous devrez renseigner le montant à payer</li>
                <li>Virement via un RIB qui vous sera envoyé par mail </li>
                <li>Chèque à l’ordre de Nuit INSA, avec au dos le nombre de places prises et le nom des personnes concernées</li>
                <li>Et vous pouvez aussi venir nous voir directement à l’INSA lors de nos nombreuses permanences</li>
            </ul>
            <br></br>
            Vous avez jusqu’à deux semaines pour payer après votre réservation ou sinon elle sera
            annulée et jusqu'au vendredi 19 Février 2022 pour payer vos places, après cette date elle ne
            sera pas comptabilisée. Votre réservation ne sera définitive qu'à réception de votre
            paiement. 
            </div> 
            <br></br>
            Veuillez envoyer vos chèques à l’adresse suivante :
            <div className="text-center">
                <br></br>
                Association Nuit INSA<br></br>
                INSA Hauts-de-France<br></br>
                Mont Houy 59313 Valenciennes
            </div>
            <br></br>
            Toute annulation après le 16 Février 2022 ne pourra être remboursée.
            <p></p>
            <h5><strong>Réservation :</strong></h5>
            <div className="text-justify" id="table-scroll2">
            Les réservations seront ouvertes dès le <strong> Mercredi 1<sup>er</sup> Décembre 2021</strong> via la rubrique “Billetterie”
            du site, <strong> aux promotions n’ayant pas pû profiter d’un gala en leur honneur (accompagné
            d’une personne de leur choix), aux diplômés et DRT ainsi qu'à leurs invités sans restriction
            de nombre.</strong>
            <br></br>
            <br></br>
            Les réservations pour les <strong>étudiants de l'INSA HDF</strong> seront ouvertes un mois plus tard, soit le <strong>Lundi 3 Janvier 2022</strong>.
            <br></br>
            <br></br>
            Les tables rondes peuvent accueillir 10 personnes maximum.
            <br></br>
            <br></br>
            L'équipe Nuit Insa se réserve le droit de compléter les tables en cas de places libres ainsi
            que le droit de modifier les placements des tables pour des raisons logistiques.
            </div>
            <br></br>
            <i>Note : Sont appelés 7A tous les diplômés 2020 et 8A tous les diplômés 2019.</i>
            <br></br>
            <br></br>
          <div className="blockquote text-center" id="table-scroll" style={{backgroundColor: "#2ca8ff", border: "none"}}> {/* #2ca8ff #2c2c2c */}
              
          <h4>Les inscriptions sont closes.</h4>
          {/* {!formReceived ? <> */}
            {/* <h4>Pour réserver, je suis &nbsp;
            
            <form>
              <input type="radio" value={isUPHF} onChange={(e) => setIsUPFH(true)} name="isUPHF" />
              <label for="isUPHF">&nbsp;UPHF (Personnel)</label>
              <br/>
              <input type="radio" value={isUPHF} onChange={(e) => setIsUPFH(false)} name="isUPHF"/>
              <label for="isUPHF">&nbsp;

            <select onChange={(e) => setYear(e.target.value)}>
                <option value={1}>1A</option>
                <option value={2}>2A</option>
                <option value={3}>3A</option>
                <option value={4}>4A</option>
                <option value={5}>5A</option>
                <option value={6}>6A</option>
                <option value={7}>7A</option>
                <option value={8}>8A</option>
            </select>
            </label>
            </form>
            et je veux réserver pour &nbsp;
             <select onChange={(e) => setNbPers(e.target.value)}>
                <option value={1}>1</option>
                <option value={2}>2</option> */}

                {/* Year 6 -> 10 bookings possible */}
{/* {(year == 6 ) ?  <><option value={3}>3</option>
                <option value={4}>4</option>
                <option value={5}>5</option>
                <option value={6}>6</option>
                <option value={7}>7</option>
                <option value={8}>8</option>
                <option value={9}>9</option>
                <option value={10}>10</option></> : */}

               {/*  UPHF -> 5 bookings possible */}
             {/* (year > 5 || isUPHF ) && <><option value={3}>3</option>
                <option value={4}>4</option>
                <option value={5}>5</option></>}
            </select>
            &nbsp;personnes (en m'incluant dedans).
          <br/>
          </h4> */}
{/*           <Button style={{margin: "1em"}} onClick={searchTable}>Rechercher une table</Button>
          </> : <PaymentMessage id="payment-message" payment={payment} allInfo={allInfo} calcTotalPrice={calcTotalPrice}/>} */} 
          </div>

          {displayTable && <>
                            <h3 className="title">Carte interactive des tables</h3>
                            <TableMap isFree={isFree} nbPers={nbPers} isUPHF={isUPHF} tableChoice={validTable}/> 
                          </>}

          {(displayForm && !formReceived) && <Container style={{color: "#2c2c2c"}}>
          <Row style={{marginTop: "1em"}}>
            <Col md="6">
              <Card className="blockquote text-center">
              <p className="category">Inscription - Table {tableChoice} ({10 - isFree[tableFormat(tableChoice)]} places disponibles)</p>
              <p>Remplissez le ou les formulaire(s) si vous avez des invités. Quand chaque personne est enregistrée (en vert), vous pouvez valider votre réservation.</p>

              <CardHeader>
              <Nav className="justify-content-center" role="tablist" tabs>
                <NavItem>
                    <NavLink
                    className={iconPills === 0 ? "active" : ""}
                    href=""
                    onClick={(e) => {
                        e.preventDefault();
                        setIconPills(0);
                    }}
                    >
                    Moi
                    </NavLink>
                </NavItem>
                  {navForm}
              </Nav>
              </CardHeader>
                <CardBody>
                  <TabContent
                    className="text-justify"
                    activeTab={"iconPills" + iconPills}
                  >
                    <TabPane tabId={`iconPills0`}>
                        <FormTable addInfo={addInfo}/>
                    </TabPane>
                    {tabForm}
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
            <Col md="6">
              <Card className="blockquote text-center">
              <p className="category">Personne(s) enregitrée(s)</p>
              <p>Pour valider votre réservation avec toutes les personnes ci-dessous, appuyez sur le bouton en bas.</p>
                <CardBody>
                    {(allInfo.length < 1) ? <p>Aucune</p> :
                    <InfoDisplayer allInfo={allInfo}/>}
                </CardBody>
                <CardFooter className="text-center">
                    
                <FormGroup>
                    <label>Moyen de paiement :</label>
                    <Input type="select" onChange={(e) => setPayment(e.target.value)}>
                        <option value=""></option>
                        <option value="Chèque">Chèque</option>
                        <option value="Virement">Virement</option>
                        <option value="Billetterie Lydia">Billetterie Lydia</option>
                       {year < 6 && <>
                                    <option value="Lydia">Lydia</option>
                                    <option value="Espèce">Espèce</option>
                                   </>}
                    </Input>
                </FormGroup>
                  {(!formSent && !formReceived) ? <Button
                    className="btn-round btn-white"
                    color="primary"
                    type="submit"
                    onClick={registerInfo}
                    size="lg"
                  >
                      Réserver - Total : {calcTotalPrice()}€
                  </Button>
                  :
                  <i className="now-ui-icons loader_refresh spin"></i>}
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </Container>}
        </Container>
      </div>
    </>
  );
}

export default TableChoice;
